module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "title fl"
  }, [_c('p', [_vm._v("移宇在线报表系统")]), _vm._v(" "), _c('p', {
    staticClass: "hospital-name"
  }, [_vm._v(_vm._s(_vm.hospitalName))])]), _vm._v(" "), _c('div', {}, [(!_vm.pathFlag) ? _c('div', {
    staticClass: "icon_out_wrap fr",
    on: {
      "click": _vm.logout
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/report/icon_out.png"
    }
  })]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "fr username"
  }, [_vm._v(_vm._s(_vm.username))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img-wrap fl"
  }, [_c('img', {
    attrs: {
      "src": "/static/report/logo_zyw.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12e7743c","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportHeader.vue
// module id = 737
// module chunks = 1